import React, { useContext } from "react";
import { Link } from "react-router-dom";
import GlobalContext from "../../context/GlobalContext";
import navLinks from "../../utils/navigation";
import socials from "../../utils/socials";
import "./footer.scss";

const Footer = () => {
	const { breakpoint } = useContext(GlobalContext);
	let k = navLinks.filter((p) => p.route !== "/admin").length / 2;
	return (
		<footer className="footer">
			<section className="footer-top">
				<span className="footer-top-first"></span>
				<div className="footer-top-mid">EPMOC</div>
				<span className="footer-top-last"></span>
			</section>
			<section className="footer-mid">
				<div className="footer-mid-left">
					{navLinks
						.filter((p) => p.route !== "/admin")
						.map(
							(navLink, id) =>
								id < k && (
									<Link key={id} to={navLink.route}>
										{navLink.text}
									</Link>
								)
						)}
				</div>
				<div className="footer-mid-mid">
					<div className="footer-mid-mid-socials">
						{socials.map((social, id) => (
							<a
								href={social.link}
								target="_blank"
								rel="noreferrer"
								title={social.linkText}
								key={id}
							>
								{social.icon}
							</a>
						))}
					</div>
					<span className="footer-mid-mid-dash"></span>
				</div>
				<div className="footer-mid-right">
					{navLinks
						.filter((p) => p.route !== "/admin")
						.map(
							(navLink, id) =>
								id >= k && (
									<Link key={id} to={navLink.route}>
										{navLink.text}
									</Link>
								)
						)}
				</div>
			</section>
			{breakpoint("mobile") && (
				<section className="footer-nav">
					{navLinks.map((navLink, index) => (
						<Link key={index} to={navLink.route}>
							{navLink.icon}
						</Link>
					))}
				</section>
			)}
			<section className="footer-bottom">
				<span>Made with ❤ by Development team.</span>
			</section>
		</footer>
	);
};

export default Footer;
